// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"556":"31caa46224a0f55fca1c","715":"f3b4401eca32e727ca14"}[chunkId] + ".js";
};